var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hw-100"},[(_vm.pointCloudController.canLoadCloud)?_c('iframe',{ref:"pointCloudModelViewer",staticClass:"full-view",attrs:{"e2e-id":"point_cloud_model","id":"point_cloud_model","src":`${_vm.publicPath}viewers/point-cloud/index.html`},on:{"load":_vm.load}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }